/**
 * 郵便番号→住所
 */
import * as httpConst from '../../../constants/httpConst'
import Vue from 'vue'

const API_PATH = `${httpConst.DRIVER_BASE}/api/addresses`

const driver_search_address = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 郵便番号からの住所検索
     * @param commit
     * @param zip_code { String } 郵便番号 xxxzzzz or xxx-zzzz形式
     * @return {Promise<unknown>}
     */
    show ({ commit },{ zip_code }) {
      const api_path = `${API_PATH}/${zip_code}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default driver_search_address
